module.exports = __webpack_public_path__ + "static/media/top_post.357deb1d.svg";